import React from "react";
import { t } from "i18next";
import { ROWS_PER_PAGE_OPTIONS, DEFAULT_ROWS_PER_PAGE } from "./TableConfig";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconButton from "@mui/material/IconButton";
import { FaCloudDownloadAlt } from "react-icons/fa";


const handleExcelDownload = (columns, displayData, rawData, filename = "تقرير_المبيعات") => {
  if (!columns || !displayData || !rawData) return;

  const visibleColumns = columns.filter(col => col.display === "true");
  const headers = visibleColumns.map(col => col.label);
  const columnNames = visibleColumns.map(col => col.name);

  const sheetData = [
    headers,
    ...rawData.map(row =>
      columnNames.map(name => {
        const value = row[name] ?? "";

        // ✅ دعم MONTH
        if (name === "_id" && value && typeof value === "object") {
          if (value.MONTH !== undefined && value.YEAR !== undefined) {
            const monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
              new Date(value.YEAR, value.MONTH - 1)
            );
            return monthName;
          }

          // ✅ دعم QUARTER
          if (value.YEAR !== undefined && value.QUARTER !== undefined) {
            return `${value.YEAR} (${value.QUARTER})`;
          }
        }
        
        if (typeof value === "number") {
          return value;  
        }

        return value;
      })
    ),
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

  worksheet["!cols"] = sheetData[0].map((_, colIndex) => {
    const maxLength = sheetData.reduce((max, row) => {
      const cell = row[colIndex];
      return Math.max(max, cell?.toString().length ?? 10);
    }, 10);
    return { wch: maxLength + 2 };
  });

  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellRef];
      if (!cell) continue;

      cell.s = {
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };

      if (typeof cell.v === "number"&&
        columnNames[C] !== "BILL_NUMBER") {
        cell.z = "#,##0";
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "تقرير");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });

  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `${filename}.xlsx`);
};



const createOptions = (title, columns, rawData) => ({
  filterType: "checkbox",
  filter: false,
  responsive: "standard",
  print: true,
  download: false,
  selectableRows: "none",
  rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
  rowsPerPage: DEFAULT_ROWS_PER_PAGE,
  searchAlwaysOpen: true,
  displayRows: false,

  textLabels: {
    body: {
      noMatch: t("NoData_Page"),
      toolTip: t("Sort"),
      columnHeaderTooltip: column => `${t("Sort")} ${column.label}`,
    },
    pagination: {
      next: t("Next"),
      previous: t("Previous"),
      rowsPerPage: t("RowsPerPage"),
    },
    viewColumns: {
      title: t("ShowColumn"),
    },
  },

  customToolbar: () => (
    <IconButton
      onClick={() => {
        const table = window.lastTableState;
        if (table) {
          const safeTitle = title?.replace(/[\\/:*?"<>|]/g, "_") || "تقرير";
          handleExcelDownload(table.columns, table.displayData, rawData, safeTitle);
        }
      }}
      title={t("Download_Excel")}
    >
      <FaCloudDownloadAlt style={{ color: "#D52953" }} />
    </IconButton>
  ),

  onTableChange: (_action, tableState) => {
    window.lastTableState = {
      columns: tableState.columns,
      displayData: tableState.displayData,
    };
  },
});

export default createOptions;
